import { createIcon } from '@chakra-ui/react';

export const AddAvatarIcon = createIcon({
  displayName: 'AddAvatarIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="32"
        // height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M15.9997 16.0003C19.6816 16.0003 22.6663 13.0156 22.6663 9.33366C22.6663 5.65176 19.6816 2.66699 15.9997 2.66699C12.3178 2.66699 9.33301 5.65176 9.33301 9.33366C9.33301 13.0156 12.3178 16.0003 15.9997 16.0003Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.54688 29.3333C4.54688 24.1733 9.6802 20 16.0002 20C17.2802 20 18.5202 20.1733 19.6802 20.4933"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.3337 24.0003C29.3337 24.427 29.2803 24.8403 29.1737 25.2403C29.0537 25.7736 28.8403 26.2937 28.5603 26.747C27.6403 28.2937 25.947 29.3337 24.0003 29.3337C22.627 29.3337 21.387 28.8136 20.4537 27.9603C20.0537 27.6136 19.707 27.2003 19.4403 26.747C18.947 25.947 18.667 25.0003 18.667 24.0003C18.667 22.5603 19.2403 21.2404 20.1737 20.2804C21.147 19.2804 22.507 18.667 24.0003 18.667C25.5737 18.667 27.0003 19.347 27.9603 20.4403C28.8137 21.387 29.3337 22.6403 29.3337 24.0003Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.987 23.9727H22.0137"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 22.0264V26.013"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
